<a class="btnn close_btn" mat-dialog-close>
  <mat-icon>{{ 'close' | translate }}</mat-icon>
</a>

<div class="modal-box">
  <div class="modal_header modal_banner d_flx">
    <div class="modal_title">
      <h2>{{ 'welcomeText' | translate }}</h2>
      <p>{{ 'welcomeDescription' | translate }}</p>
      <a class="text_link">{{ 'learnMore' | translate }}</a>
    </div>

    <div class="modal_head_figure">
      <figure>
        <img [src]="assetConst.phoneImage" alt="phone" />
      </figure>
    </div>
  </div>

  <div class="modal_body">
    <div class="modal_subtitle">
      <h3>{{ 'welcomeUser' | translate }},</h3>
      <p>
        {{
          (signUpWithEmail ? 'signInemailDescription' : 'signInDescription')
            | translate
        }}
      </p>
    </div>

    <form
      [formGroup]="signUpFormGroup"
      (ngSubmit)="onSubmit()"
      class="tab_content">
      <ng-container *ngIf="signUpWithEmail">
        <div class="form_filed gap_m">
          <div class="form_group">
            <mat-form-field>
              <input
                matInput
                [placeholder]="'enterEmail' | translate"
                formControlName="email"
                type="email"
                class="form_control" />
            </mat-form-field>
            <mat-error
              *ngIf="
                signUpFormGroup['controls']['email'].hasError('required') &&
                submitted
              ">
              {{ 'email' | translate }} {{ 'isRequired' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                signUpFormGroup['controls']['email'].hasError('pattern') &&
                submitted
              ">
              {{ 'PleaseEnterValid' | translate }}
              {{ 'email' | translate }}
            </mat-error>
          </div>

          <div class="form_group">
            <mat-form-field>
              <input
                matInput
                [placeholder]="'EnterPassword' | translate"
                class="form_control"
                [type]="hiddenPasswordVisibility ? 'password' : 'text'"
                formControlName="password" />
            </mat-form-field>
            <span
              (click)="hiddenPasswordVisibility = !hiddenPasswordVisibility"
              class="pass_ico">
              <mat-icon>{{
                !hiddenPasswordVisibility ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </span>
            <mat-error
              *ngIf="
                submitted &&
                signUpFormGroup.controls['password'].hasError('required')
              ">
              {{ 'Password' | translate }} {{ 'isRequired' | translate }}
            </mat-error>
            <mat-error
              *ngIf="signUpFormGroup.controls['password'].hasError('pattern')">
              <ul>
                <li
                  *ngFor="let err of formErrors"
                  [ngClass]="{
                    greenClass: checkValidations(
                      signUpFormGroup.controls['password'],
                      err.key
                    ),
                    redClass: !checkValidations(
                      signUpFormGroup.controls['password'],
                      err.key
                    )
                  }">
                  <i class="fa-solid fa-circle-check"></i>
                  {{ err.message | translate }}
                </li>
              </ul>
            </mat-error>
          </div>

          <div class="form_group">
            <mat-form-field>
              <input
                matInput
                [placeholder]="'enterconfirmPassword' | translate"
                class="form_control"
                [type]="hiddenConfirmPasswordVisibility ? 'password' : 'text'"
                formControlName="confirmPassword" />
            </mat-form-field>
            <span
              (click)="
                hiddenConfirmPasswordVisibility =
                  !hiddenConfirmPasswordVisibility
              "
              class="pass_ico">
              <mat-icon>{{
                !hiddenConfirmPasswordVisibility
                  ? 'visibility_off'
                  : 'visibility'
              }}</mat-icon>
            </span>
            <mat-error
              *ngIf="
                submitted &&
                signUpFormGroup.controls['confirmPassword'].hasError('required')
              ">
              {{ 'confirmPassword' | translate }} {{ 'isRequired' | translate }}
            </mat-error>
            <mat-error
              *ngIf="
                submitted &&
                signUpFormGroup.controls['confirmPassword']?.hasError(
                  'mustMatch'
                )
              ">
              {{ 'PasswordMatch' | translate }}
            </mat-error>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!signUpWithEmail" class="form_group phone-input">
        <ngx-mat-intl-tel-input
          [preferredCountries]="['ly']"
          name="phone"
          describedBy="phoneInput"
          formControlName="phoneNo"
          #phone
          (countryChanged)="countryChangedEvent($event)">
        </ngx-mat-intl-tel-input>
      </div>
      <mat-error
        *ngIf="
          (signUpFormGroup.get('phoneNo')?.value === '' ||
            signUpFormGroup.get('phoneNo')?.value === null) &&
          submitted &&
          signUpFormGroup.get('phoneNo')?.hasError('required')
        ">
        {{ 'PhoneNumber' | translate }}
        {{ 'isRequired' | translate }}
      </mat-error>
      <mat-error
        *ngIf="
          submitted &&
          (signUpFormGroup.get('phoneNo')?.value === undefined ||
            signUpFormGroup.get('phoneNo')?.hasError('validatePhoneNumber'))
        ">
        {{ 'PleaseEnterValid' | translate }}
        {{ 'PhoneNumber' | translate }}
      </mat-error>

      <div class="submit_btn mt_20">
        <button type="submit" class="btnn btn_primary">
          {{ 'continue' | translate }}
        </button>
      </div>
    </form>
    <button type="button" class="email_login" (click)="loginTypeChanged()">
      {{
        (signUpWithEmail ? 'signupWithPhone' : 'signupWithEmail') | translate
      }}
    </button>

    <div class="or-box">
      <p>{{ 'or' | translate }}</p>
    </div>
    <ul class="social-login">
      <!-- <li>
        <i class="fa-brands fa-facebook-f"></i>
      </li> -->
      <li>
        <asl-google-signin-button type="icon" size="large">
        </asl-google-signin-button>
      </li>
    </ul>
    <p class="signup_text">
      {{ 'alreadyMember' | translate }}
      <button type="button" (click)="openLoginDialog()">
        {{ 'signIn' | translate }}
      </button>
    </p>
  </div>
</div>
